import { ModuleWithProviders } from '@angular/core';
import { ModelRegistryService as ModelRegistryServiceBase } from '@core/shared/model';
import { modelFactoryFrontendProviders } from './model-factory-frontend-provider';
import { ModelRegistryService } from './model-registry.service';
import * as i0 from "@angular/core";
export let CoreModelModule = /*#__PURE__*/(() => {
  class CoreModelModule {
    static forRoot() {
      return {
        ngModule: CoreModelModule,
        providers: [
        // ModelRegistryService,
        {
          provide: ModelRegistryServiceBase,
          useExisting: ModelRegistryService
        }, ...modelFactoryFrontendProviders()]
      };
    }
    static {
      this.ɵfac = function CoreModelModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreModelModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreModelModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return CoreModelModule;
})();